var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-table',{attrs:{"columns":_vm.columns,"data-source":_vm.bankList,"pagination":false,"bordered":true,"scroll":{ x: 500 }},scopedSlots:_vm._u([{key:"status",fn:function(text){return [_c('a-tag',{attrs:{"color":_vm.getStatusColor(text)}},[_vm._v(" "+_vm._s(_vm.getStatusText(text))+" ")])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }